/**
 * Where to go after signing in. Only same-origin paths ("/listings?x=1") are honoured — anything else
 * (absolute URLs, protocol-relative "//evil.com", back-slash tricks, the auth pages themselves) falls back.
 */
export function safeNext(raw: string | null | undefined, fallback = '/'): string {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//') || raw.startsWith('/\\')) return fallback;
  try {
    const u = new URL(raw, window.location.origin);
    if (u.origin !== window.location.origin) return fallback;
    if (/^\/(login|signup)(\/|$)/.test(u.pathname)) return fallback;
    return u.pathname + u.search + u.hash;
  } catch {
    return fallback;
  }
}
